import { render, staticRenderFns } from "./goods-label.vue?vue&type=template&id=43ed4cfc&scoped=true"
import script from "./goods-label.vue?vue&type=script&lang=js"
export * from "./goods-label.vue?vue&type=script&lang=js"
import style0 from "./goods-label.vue?vue&type=style&index=0&id=43ed4cfc&prod&lang=css"
import style1 from "./goods-label.vue?vue&type=style&index=1&id=43ed4cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_b5e12a4b1c1729405afdf532a227c02e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ed4cfc",
  null
  
)

export default component.exports